import React, { useState, useEffect, useRef } from "react";
import Icon from "../../components/AppIcon";

import ServiceHero from "./components/ServiceHero";
import ServiceOverview from "./components/ServiceOverview";
import BrandFilmsSection from "./components/BrandFilmsSection";
import ExecutivePortraitsSection from "./components/ExecutivePortraitsSection";
import EventDocumentationSection from "./components/EventDocumentationSection";
import AerialCinematographySection from "./components/AerialCinematographySection";
import TechnicalSpecifications from "./components/TechnicalSpecifications";
import CorporatePartnershipApproach from "./components/CorporatePartnershipApproach";
import ServicePackages from "./components/ServicePackages";
import ProcessTimeline from "./components/ProcessTimeline";
import CallToAction from "./components/CallToAction";
import ServicesInteractive from "./components/ServicesInteractive";

const CorporateSolutionsServices = () => {
  return <ServicesInteractive />;
};

export default CorporateSolutionsServices;
